const STATE = {
  LIVE: 'liftoff.viddsee.com',
  STAGING: 'blueberry.viddsee.com',
  TEST: 'strawberry.viddsee.com',
  LOCAL: 'localhost',
};

const STATE_VARIABLE = {
  [STATE.LIVE]: {
    BASE_URL: 'https://www.viddsee.com',
    API_URL: 'https://www.viddsee.com/v1/',
  },
  [STATE.STAGING]: {
    BASE_URL: 'http://blueberry.viddsee.com',
    API_URL: 'http://blueberry.viddsee.com/v1/',
  },
  [STATE.TEST]: {
    BASE_URL: 'https://strawberry.viddsee.com',
    API_URL: 'https://strawberry.viddsee.com/v1/',
  },
  [STATE.LOCAL]: {
    BASE_URL: 'http://localhost:3000',
    API_URL: 'https://strawberry.viddsee.com/v1/',
  },
};

// Set Application Current State if its host matches the given STATE,
// otherwise, set it to Test State
const currentState = (STATE_VARIABLE[window.location.hostname])
  ? window.location.hostname
  : STATE.TEST;

const AWS = {
  UPLOAD_ENDPOINT: 'https://viddsee-liftoff.s3.amazonaws.com',
  KEY: 'AKIAJDPH6I3TWR2J5TVQ',
  BUCKET: 'viddsee-liftoff',
  SIGNER_URL: uuid => `${STATE_VARIABLE[currentState].API_URL}liftoffs/${uuid}/upload_signature`,
};

export default {
  ...STATE_VARIABLE[currentState],
  AWS,
};



// WEBPACK FOOTER //
// ./src/config/variables.js